import request from '@/utils/request'

/**
 * 药品证列表
 * @param {*} data
 * @returns
 */
export const getYPZList = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/ypz/list`,
    data: data
})

/**
 * 新增药品证
 * @param {*} data
 * @returns
 */
export const addYPZ = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/ypz/add`,
    data: data
})

/**
 * 查询药品证
 * @returns
 * @param id
 */
export const getYPZ = (id) => request({
    method: 'get',
    url: `/yzdservice/api/enterprise/ypz/detail/${id}`
})

/**
 * 编辑药品证
 * @param {*} data
 * @returns
 */
export const updateYPZ = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/ypz/edit`,
    data
})

/**
 * 删除药品证
 * @returns
 * @param id
 */
export const deleteYPZ = (id) => request({
    method: 'delete',
    url: `/yzdservice/api/enterprise/ypz/delete/${id}`
})
/**
 * 删除药品证图片
 * @param {*} id
 * @returns
 */
export const deleteYPZImage = (id) => request({
    method: 'delete',
    url: `/yzdservice/api/enterprise/ypz/deletefile/${id}`
})

/**
 * 核销药品证
 * @param {*} id
 * @returns
 */
export const writeOffYPZ = (id) => request({
    method: 'put',
    url: `/yzdservice/api/enterprise/ypz/WriteOff/${id}`
})
/**
 * 取消核销药品证
 * @returns
 * @param data
 */
export const cancelWriteOffYPZ = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/ypz/cancelWriteOff`,
    data
})

/**
 * 证书审批详情
 * @param {*} id
 * @returns
 */
export const getCredentials = (id) => request({
    method: 'get',
    url: `/yzdservice/api/enterprise/credentials/common/splc/${id}`
})

/**
 * 导出
 * @returns
 * @param data
 */
export const excelwriter = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/ypz/excelwriter`,
    data,
    responseType: 'blob'
})

/**
 * 手动录入
 * @param {*} data
 * @returns
 */
 export const manualEntry = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/ypz/record`,
    data
})

/**
 * 购买证化学品级联
 * @param {*} data
 * @returns
 */
 export const gethxpJlgmz = (data) => request({
    method: 'get',
    url: `/yzdservice/api/enterprise/ypz/getHxpCascader`,
    data
})
